<template>
  <div class="user-res-info">
    <el-page-header @back="onBack" content="权限详情"></el-page-header>
    <base-table
      ref="table"
      url="/project/findByUser"
      :toolbar="toolbar"
      :columns="columns"
      border
    ></base-table>
    <extra-res-dialog
      title="查看特殊权限"
      v-model="extraResDialog.show"
      :show-ok="false"
      :show-cancel="false"
      :projectid="projectid"
      :uid="uid"
      :domain="domain"
      disable-edit
    >
    </extra-res-dialog>
  </div>
</template>
<script>
export default {
  name: 'user-res-info',
  data() {
    var domain = this.$route.query.domain
    var uid = this.$route.query.uid
    return {
      uid,
      domain,
      projectid: '',
      toolbar: {
        formItems: [
          {
            label: '项目名称',
            prop: 'name',
            field: 'p.name',
            cp: this.$ComparePatterns.Like
          }
        ],
        query: {
          did: domain,
          uid,
          SortFields: JSON.stringify([{ Field: 'p.name', Order: 1 }])
        }
      },
      columns: [
        {
          bind: { label: '项目名称', prop: 'name' },
          default: {
            component: 'cell-text',
            bind: {
              style:
                'color: #409EFF; cursor: pointer; border-bottom: 1px dotted #409eff;',
              formatter(scope, defaultValue) {
                return defaultValue
              }
            },
            on: {
              click: (scope) => {
                this.$router.push({
                  path: '/ProjectSetting',
                  query: { id: scope.row.id }
                })
              }
            }
          }
        },
        {
          bind: { label: '角色', prop: 'role_names' },
          default: {
            component: 'cell-render-vnode',
            bind: {
              vnode: (scope, defaultValue) => {
                if (!defaultValue) {
                  return null
                }
                const roleNames = defaultValue.split(',')
                return (
                  <div class='role-tag-wrap'>
                    {roleNames.map((roleName) => {
                      return <el-tag size='mini'>{roleName}</el-tag>
                    })}
                  </div>
                )
              }
            }
          }
        },
        {
          bind: { label: '特殊权限', width: 100 },
          default: {
            component: 'cell-buttons',
            bind: {
              buttons: [
                {
                  label: '查看',
                  type: 'text',
                  click: (scope) => {
                    this.projectid = scope.row.id
                    this.extraResDialog.show = true
                  }
                }
              ]
            }
          }
        }
      ],
      extraResDialog: {
        show: false
      }
    }
  },
  methods: {
    onBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.user-res-info {
  box-sizing: border-box;
  height: 100%;
  .el-page-header {
    padding: 15px;
  }
  .base-table {
    height: calc(100% - 54px);
  }
  .role-tag-wrap {
    .el-tag + .el-tag {
      margin-left: 6px;
    }
  }
}
</style>
